module.exports = __webpack_public_path__ + "static/media/faqBalance-es-vi.db67fb71.vtt";